import { IntlMoney } from "@funcional/react-intl-ui";
import { Tooltip } from "@material-ui/core";
import { useTooltipCommonStyles } from "../styles/tooltipCommonStyles";
import { useState } from "react";
import { openTooltip } from "../helpers";
import { IRefundTransaction, IRefundTransactionProduct, ITooltipParams } from "../contracts";

export function ToolTipRefundAmount({ row, item }: ITooltipParams) {
    const classes = useTooltipCommonStyles();
    const pbmSales: IRefundTransaction = row?.original;
    const pbmSalesProducts: IRefundTransactionProduct[] = row?.original?.pbmSalesProducts; 
    const [open, setOpen] = useState<boolean>(false);
    
    if (pbmSalesProducts?.length > 1) {
      const productItens = pbmSalesProducts?.map((pbmSaleProduct) => {
        return pbmSaleProduct[item];
      }); 

      const content = <div style={{maxHeight: "60px", overflowY: "auto"}}>{
        productItens.map((value, index) => {
          const refundAmount = pbmSales.canceledTransactionDate ? "R$ 0,00" : <IntlMoney value={pbmSalesProducts[index][item]}/>;
          return (<div key={index} style={{marginRight: "10px"}}>{index+1}: {value ? refundAmount : "-"} </div>);
      })
      }</div>;
        
      return (
        <Tooltip classes={{tooltip: classes.customTooltip}} arrow placement="right"
        open={open}
        title= {content}>
          <a style={{cursor: "pointer", textDecoration: "underline"}} onClick={() => openTooltip(open, setOpen)}>{open ? "ver menos" : "ver mais ..."}</a>
        </Tooltip> 
      );
    } 
    
    const refundAmount = pbmSales.canceledTransactionDate ? "R$ 0,00" : <IntlMoney value={pbmSalesProducts[0][item]}/>;
    const refundAmountExists = pbmSalesProducts[0][item] ? refundAmount : "-";

    return <span>{pbmSalesProducts ?  refundAmountExists : "carregando..."}</span>;
}